import './data-table.scss';
import { TableHTMLAttributes } from 'react';
import { PaginationRequest } from '../../clients/quipli-service/pagination/pagination';
import { PaginatorProps } from '../paginator/paginator';
import { ReactNode } from 'react';
import { MobileDataTable } from './mobile-data-table';
import { DesktopDataTable } from './desktop-data-table';
import { useResponsive } from '../../hooks/use-reponsive';

export type DataTableColumn = {
  key: string;
  label?: string | JSX.Element | ReactNode;
  hide?: boolean;
  showRule?: 'OnlyMobile' | 'OnlyDesktop' | 'Both';
  mobileShowRule?: 'fullrow' | 'halfrow';
  fixedAsFirst?: boolean;
  fixedAsLast?: boolean;
  isCheckBoxColumn?: boolean;
  className?: string;
  sortable?: boolean;
  sortField?: string;
};

export type DataTableRow = {
  className?: string;
  redirectTo?: string;
  mobileHeader: string | JSX.Element | ReactNode;
  mobileHeaderAction?: string | JSX.Element | ReactNode;
  fields: Record<string, string | JSX.Element | ReactNode>;
  data?: any;
  extraRow?: {
    content: string | JSX.Element | ReactNode;
    className?: string;
  };
  key?: string;
};

export type DataTableSort = {
  field: string;
  direction: 'asc' | 'desc';
  onSort: (sortBy: string, sortDirection: 'asc' | 'desc') => void;
};

export type DataTableProps<TPaginator extends PaginationRequest> = TableHTMLAttributes<HTMLTableElement> &
  Partial<PaginatorProps<TPaginator>> & {
    data: DataTableRow[];
    columnNames: DataTableColumn[];
    showAlwaysDesktop?: boolean;
    title?: { text: string; className?: string };
    tabs?: JSX.Element | ReactNode;
    noDataText?: string;
    isLoading?: boolean;
    wrapperClassNames?: string;
    onCheckBoxSelect?: (selectedData: any[]) => void;
    checkBoxActions?: JSX.Element | ReactNode;
    sort?: DataTableSort;
  };

export const DataTable = <TPaginator extends PaginationRequest>({
  showAlwaysDesktop,
  ...props
}: DataTableProps<TPaginator>) => {
  const { isMobile } = useResponsive();

  return isMobile && !showAlwaysDesktop ? <MobileDataTable {...props} /> : <DesktopDataTable {...props} />;
};
